// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"6de82ddb","272":"778000ec","413":"fecc302a"}[chunkId] + ".chunk.js";
};